import { lazy } from 'react';

const loadTemplateEdit = () => import('modules/settings/templates/template-editor/pages/TemplateEditPage');
export const TemplateEditPage = lazy(loadTemplateEdit);
